import { uuidv7 } from '../lib/uuidv7.ts';
import { ApiError } from './client.ts';

/** Valeur de l'en-tête If-Match pour la version lue sur l'objet (ETag faible : `"3"`). */
export function ifMatch(version: number): string {
  return `"${version}"`;
}

/** Identifiant et clé d'idempotence d'une création : générés une fois par saisie, réutilisés si l'on réessaie. */
export function newCreation(): { id: string; key: string } {
  const id = uuidv7();
  return { id, key: `create-${id}` };
}

export function isStatus(err: unknown, status: number): boolean {
  return err instanceof ApiError && err.problem.status === status;
}

/** 412 : l'objet a changé depuis sa lecture. */
export function isConflict(err: unknown): boolean {
  return isStatus(err, 412);
}

/** Message par champ renvoyé par le serveur (422), à afficher à côté du champ. */
export function fieldError(err: unknown, field: string): string | undefined {
  if (!(err instanceof ApiError)) return undefined;
  const hit = err.problem.errors?.find((e) => e.field === field || e.field === `/${field}` || e.field.endsWith(`.${field}`));
  return hit?.message;
}
